import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', dir: 'ltr' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳', dir: 'ltr' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिंदी', flag: '🇮🇳', dir: 'ltr' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵', dir: 'ltr' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇵🇹', dir: 'ltr' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷', dir: 'ltr' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷', dir: 'ltr' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский', flag: '🇷🇺', dir: 'ltr' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', dir: 'ltr' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', flag: '🇮🇩', dir: 'ltr' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', flag: '🇻🇳', dir: 'ltr' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย', flag: '🇹🇭', dir: 'ltr' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export const RTL_LANGUAGES: ReadonlySet<string> = new Set(['ar', 'he', 'ur', 'fa']);

export const TRANSLATION_NAMESPACES = [
  'common', 'header', 'nav', 'org', 'dashboard', 'sales', 'finance',
  'hr', 'inventory', 'purchasing', 'cash', 'credit', 'expenses',
  'warehouse', 'products', 'crm', 'manufacturing', 'workflow',
  'service', 'tax', 'helpdesk', 'attendance', 'retail', 'education',
  'transportation', 'realestate', 'healthcare', 'ecommerce', 'pos',
  'storage', 'admin', 'superuser', 'projects',
] as const;

export function isRtl(lang: string): boolean {
  return RTL_LANGUAGES.has(lang);
}

export function getLanguageDirection(lang: string): 'ltr' | 'rtl' {
  return isRtl(lang) ? 'rtl' : 'ltr';
}

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation'],

    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'bms-language',
      caches: ['localStorage'],
    },

    interpolation: {
      // Safe: React escapes JSX output. Do NOT use t() output with
      // dangerouslySetInnerHTML, raw HTML templates, or non-React renderers.
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
